import { Scene } from "phaser";

// The HUD scene is the scene that shows the points and the remaining time.
export class HistoryScene extends Scene {
    
    constructor() {
        super("HistoryScene");
    }

    init(data) {
        //this.cameras.main.fadeIn(500, 0, 0, 0);
    }

    create() {
        this.scene.bringToTop('HistoryScene');
        // Create a transparent input zone that covers the entire screen
        this.inputZone = this.add.zone(0, 0, this.scale.width, this.scale.height)
        .setOrigin(0)
        .setInteractive(); // Make it interactive to capture clicks

        this.buttonClickSound = this.sound.add('button-click');

        this.fullContainer = this.add.container(0, this.scale.height/2 - this.scale.height/4)
               
        this.cameras.main.setBackgroundColor('rgba(21, 21, 21, 0.85)');

        this.graphics = this.add.graphics();

        this.graphics.fillStyle(0x05022D, 1);//0x05022D

        this.graphics.fillRoundedRect(this.scale.width/2-343, 32, 343*2 ,this.scale.height/2, 32);

        this.fullContainer.add(this.graphics)

        this.title = this.add.text(this.scale.width/2-343+32, 64, `DRAW RESULTS`,  { fontFamily: 'Oswald', fontSize: 48, color: '#ffffff' }).setOrigin(0);
        this.title.setFontStyle('700')

        this.fullContainer.add(this.title)

        this.buttonSprite = this.add.sprite(this.scale.width/2 +343-64,88, "pack" ,'x-icon.png').setInteractive();
        this.buttonSprite.setTint(0x757B8C)
        this.buttonSprite.setScale(2)
        
        this.buttonSprite.on('pointerup', () => {
            this.buttonClickSound.play();
            this.tweens.add({
                targets: this,
                scaleX: 0.8 ,
                scaleY: 0.8,
                duration: 50, // Duration of the tween (in milliseconds)
                ease: 'Power2',
                onComplete: () => {
                    this.scene.stop()
                }
            });
        
        });

        this.fullContainer.add(this.buttonSprite)


        this.subTitle = this.add.text(this.scale.width/2 -343+32, 160, `All draws of Lotto6 from past seasons.`,  { fontFamily: 'Montserrat', fontSize: 30, color: '#ffffff' }).setOrigin(0);
        this.subTitle.setFontStyle('500')

        this.fullContainer.add(this.subTitle)

        //console.log("this.fullContainer.getBounds()", this.fullContainer.getBounds())

        var pastDraws =  this.registry.get('past_draws');



        if(pastDraws == undefined){
            pastDraws = []
        }
        
        if(pastDraws.length == 0){
            this.noResults = this.add.text(this.scale.width/2, this.scale.height/4 + 100, `No Results Found`,  { fontFamily: 'Montserrat', fontSize: 30, color: '#ffffff' }).setOrigin(0);
            this.noResults.setFontStyle('500').setOrigin(0.5)
    
            this.fullContainer.add(this.noResults)
        }else{
            this.CreatePastDraws(pastDraws)
        }

        
    }

    CreatePastDraws(drawresults){


        const gridTable = this.rexUI.add.scrollablePanel({
            x: this.scale.width/2, 
            y:  this.fullContainer.y + this.subTitle.y + this.subTitle.height + 100,
            width:  343*2,
            height: this.scale.height/4,
            originY: 0,

            scrollMode: 0,
            background: this.rexUI.add.roundRectangle({
                color: "0x05022D",
                // strokeColor:"#FFFFF",
                radius: { tl: 0, tr: 0, bl: 32, br: 32 }
            }),
            panel: {
                child: this.CreatePanel(this),
                //mask: { padding: 30, },
            },
            space: { left: 40, right: 20, top: 0, bottom: 20, panel: 10}
        })
        .layout()

        // this.Results = this.add.text(  343, this.scale.height/4 + 100, drawresults.length,  { fontFamily: 'Montserrat', fontSize: 30, color: '#ffffff' }).setOrigin(0);
        // this.Results.setFontStyle('500').setOrigin(0.5)

        const panelContent = gridTable.getElement('panel');
        let Tcontainer = this.createTableContainer(drawresults)
        panelContent.add(Tcontainer);

        gridTable.layout();


        //this.fullContainer.add(gridTable)

    }

    createTableContainer(item) {

        // // Create a graphics object for the grid borders
        // const gridBorders = this.add.graphics();
        
        // // Set the line style for the grid borders
        // gridBorders.lineStyle(2, 0xFFFFFF, 0.5); // 2px white lines with 50% opacity
        
        // // Function to draw borders for the grid that will be called after the table is populated
        // const drawGridBorders = (container) => {
        //     gridBorders.clear(); // Clear any previous drawings
            
        //     // Get the bounds of the container
        //     const bounds = container.getBounds();
        //     const cellWidth = bounds.width / 2; // 2 columns
        //     const headerHeight = 80; // Height of the header row
        //     const rowHeight = 80; // Height of each data row
            
        //     // Draw horizontal lines (row separators)
        //     for (let i = 0; i <= item.length; i++) {
        //         const y = bounds.y + headerHeight + (i * rowHeight);
        //         gridBorders.moveTo(bounds.x, y);
        //         gridBorders.lineTo(bounds.x + bounds.width, y);
        //     }
            
        //     // Draw vertical line (column separator)
        //     const x = bounds.x + cellWidth;
        //     gridBorders.moveTo(x, bounds.y);
        //     gridBorders.lineTo(x, bounds.y + bounds.height);
            
        //     // Draw outer border
        //     gridBorders.strokeRect(bounds.x, bounds.y, bounds.width, bounds.height);
            
        //     // Stroke all the lines
        //     gridBorders.strokePath();
        // };


        const tableContainer = this.rexUI.add.gridSizer({
            column: 2,
            width: 300*2,
            row: item.length+ 1,  // +1 for headers
            space: { 
                column: 400, 
                row: 80,
                left: 10,
                right: 10,
                top: 20,
                bottom: 20
            },
            //background: roundedRect,
            rowProportions: 1,
            columnProportions: [1, 1], // make both columns 50%
        });

        const Header1 = this.add.text(this.subTitle.x + 75,  this.subTitle.y + this.subTitle.height + 48, `DRAW DATE`, {
            fontSize: '24px',
            fontFamily: 'Oswald',
            color: '#F9F9FF',
            align: 'center',
            lineSpacing: 10,
            wordWrap: { width:  186*2, useAdvancedWrap: true }
        });
        Header1.setOrigin(0,0.5)
        Header1.setFontStyle('700')

        this.fullContainer.add(Header1)

        // tableContainer.add(Header1, 0, 0, 'center', 0, false);


        const Header2 = this.add.text(325*2 - 50,  this.subTitle.y + this.subTitle.height + 48, `DRAW NUMBER`, {
            fontSize: '24px',
            fontFamily: 'Oswald',
            color: '#F9F9FF',
            align: 'center',
            lineSpacing: 10,
            wordWrap: { width:  186*2, useAdvancedWrap: true }
        });
        Header2.setOrigin(1,0.5)
        Header2.setFontStyle('700')


        this.fullContainer.add(Header2)


        this.headerBorderGraphics = this.add.graphics();
        this.headerBorderGraphics.lineStyle(2, 0x5F5F5F, 1);
        this.headerBorderGraphics.strokeRoundedRect(this.subTitle.x,Header1.y-Header1.height/2 -14, 310*2, 60, 10);
        this.headerBorderGraphics.setDepth(10)

        this.fullContainer.add(this.headerBorderGraphics)
        

        // tableContainer.add(Header2, 1, 0, 'center', 0, false);



        	

        item.forEach((row, rowIndex) => {


                //console.log("row", row)
                const isEvenRow = rowIndex % 2 === 0; // Determine if the row is even

                // const rowBackground = this.add.graphics();
                // rowBackground
                //     .fillStyle(isEvenRow ? 0xf0f0f0 : 0xdcdcdc) // Alternate row color
                //     .fillRect(0, 0, 560, 40); // Adjust the row size as needed

                // // // Add the background to the table
                // tableContainer.addBackground(rowBackground)// background =this.rexUI.add.roundRectangle(0, 0, 2, 2, 10, "0x0000ff");
                // // Create a click zone for the entire row
                
                
                // Add the click zone to the table
                //tableContainer.add(rowClickZone, 0, rowIndex + 1, 'left', { left: 0, right: 0, top: 0, bottom: 0 }, true);


                // // Zebra fill color
                // const bgColor = (rowIndex % 2 === 0) ? 0x05022D : 0x000000;

                // // Create full-width rectangle background
                // const bgRect = this.add.rectangle(0, 0, 2, 2, bgColor)
                // .setOrigin(0) // top-left
                // .setDepth(-1);
                // //.setStrokeStyle(1, 0x999999); // optional border

                // // Add background as full-row cell spanning 2 columns
                
                // tableContainer.addBackground(bgRect, rowIndex, 0, 2, 1); // (child, row, col, colspan, rowspan)
                
                



                const container1 = this.add.container(400, 300);

                // const bg1 = this.add.graphics().fillStyle(0xff0000).fillRect(0, 0, 300, 30);
        
                // container1.add(bg1);


                const text = this.add.text(0, 0, this.formatDate(row.draw_date), {
                    fontSize: '24px',
                    fontFamily: 'Montserrat',
                    color: '#F9F9FF',
                    align: 'left',
                    lineSpacing: 10,
                    wordWrap: { width:  186*2, useAdvancedWrap: true }
                });

                container1.add(text);

                // container1.setInteractive(new Phaser.Geom.Rectangle(0, 0, 300,30), Phaser.Geom.Rectangle.Contains);
                // container1
                // .on('pointerdown', () =>this.handleClick(row.id));

                // tableContainer.add(text, 0, rowIndex + 1, 'left', 0, false);

                tableContainer.add(container1, 0, rowIndex, 'center', 0, true);


                const container2 = this.add.container(400, 30);

                // const bg2 = this.add.graphics().fillStyle(0xfffff00).fillRect(-270, 0, 300, 30);
        
                // container2.add(bg2);
                //const paddedId = String(row.id).padStart(4, '0');
                const share_amount = this.add.text(-90, 12, row.id , {
                    fontSize: '24px',
                    fontFamily: 'Montserrat',
                    color: '#F9F9FF',
                    align: 'right',
                    lineSpacing: 10,
                    wordWrap: { width:  186*2, useAdvancedWrap: true }
                }).setOrigin(1,0.5);

                //share_amount.setOrigin(0.5).setInteractive().on('pointerdown', () => this.handleClick(row.id));
                container2.add(share_amount);

                const view_history = this.add.sprite(12, 12, "view-history").setInteractive();
                view_history.setScale(1.2)
                view_history.setOrigin(0.5)
                view_history.on('pointerup', () => this.handleClick(row.id));
                container2.add(view_history)

                tableContainer.add(container2, 1, rowIndex, 'center', 0, true);



        });

        // tableContainer.setChildrenInteractive()
        //     .on('child.click', function (child) {
        //         var gridIndex = tableContainer.childToGridIndex(child);
        //         console.log(`click ${gridIndex.x},${gridIndex.y}\n`);
        //     })

        // Call the function to draw the grid borders after the table is populated
        //drawGridBorders(tableContainer);
 
        return tableContainer;

    }

        // Function to handle clicks
        handleClick(id) {
            this.scene.manager.scenes.forEach(scene => {

                if (scene.scene.isActive()) {
                    // Pause the scene
                    if (scene.scene.key != "HudScene" && scene.scene.key != "MainScene"){
                        scene.scene.stop();
                    }
                }
            });
            this.scene.start("ResultsScene", {draw_date_id: id})
        };
    

    formatDate(inputDate) {
        // Parse the input date string
        const date = new Date(inputDate);
    
        // Get month, day, and year
        const month = date.getMonth() + 1; // Months are zero-based
        const day = date.getDate();
        const year = date.getFullYear();
    
        // Format to MM/DD/YYYY
        return `${day}/${month}/${year}`;
    }

    CreatePanel(scene) {
        var panel = scene.rexUI.add.sizer({
            orientation: 'y',
            space: { top: 0, bottom: 20 }
        })
    
        return panel;
    }
}